import React, { useEffect, useState } from 'react';
import { executionOperationsService } from '../../services/executionOperationsService';

export const OperationsRuntimePage: React.FC = () => {
  const [flags, setFlags] = useState<unknown[]>([]);
  const [metrics, setMetrics] = useState<Record<string, unknown> | null>(null);
  const [scheduler, setScheduler] = useState<unknown[]>([]);
  const [alerts, setAlerts] = useState<unknown[]>([]);
  const [audit, setAudit] = useState<unknown[]>([]);

  useEffect(() => {
    void (async () => {
      const [f, m, s, a, c] = await Promise.all([
        executionOperationsService.getFeatureFlags(),
        executionOperationsService.getMetrics(),
        executionOperationsService.getScheduler(),
        executionOperationsService.getAlerts(),
        executionOperationsService.getConfigurationAudit(),
      ]);
      setFlags(f.data || []);
      setMetrics(m.data || null);
      setScheduler(s.data || []);
      setAlerts(a.data || []);
      setAudit(c.data || []);
    })();
  }, []);

  return (
    <div className="space-y-4 grid gap-4">
      <Block title="Feature flags" data={flags} />
      <Block title="Runtime metrics" data={metrics} />
      <Block title="Scheduler" data={scheduler} />
      <Block title="Alerts" data={alerts} />
      <Block title="Configuration audit" data={audit} />
    </div>
  );
};

const Block: React.FC<{ title: string; data: unknown }> = ({ title, data }) => (
  <div className="rounded-xl border border-enterprise-200 bg-white p-4 shadow-sm">
    <h2 className="mb-3 font-semibold text-enterprise-900">{title}</h2>
    <pre className="max-h-64 overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(data, null, 2)}</pre>
  </div>
);
